import React from "react";

export default function LoadingSpinner() {
    return (
        <div className="loading-spinner-parent">
            <div className="lds-dual-ring"></div>
        </div>
    );
}